import { render, staticRenderFns } from "./home-module.vue?vue&type=template&id=aee6a29a&scoped=true&"
import script from "./home-module.vue?vue&type=script&lang=ts&"
export * from "./home-module.vue?vue&type=script&lang=ts&"
import style0 from "./home-module.vue?vue&type=style&index=0&id=aee6a29a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee6a29a",
  null
  
)

export default component.exports